
export const status = {
    EMAIL: 'Email',
    EMAILLINK: 'Emaillink',
    PHONE: 'Phone',
    SIGNUP: 'SignUp',
    NONE: 'Noen',
    GMAIL: 'Gmail'  
};